<template>
    <div class="squad-players">
        <div v-for="(player, index) in playerss" :key="index" class="squad-player"
            :class="{ motmsq: motm && !userVote && user_login_info, 'selected-player': selectedIndex === index }"
            @click="choosePlayer(index)">
            <div class="ianc">
                <img class="playerpic" :src="player.img" alt="">
                <span class="name">{{ player.name }}</span>
                <span v-if="motm && player.votes > 0" class="vc">
                    {{ player.votes }} {{ player.votes > 1 ? 'Votes' : 'Vote' }}
                </span>
                <span v-if="selectedIndex === index" :id="player.fixture_id" :data-name="player.name" @click="admitVote"
                    class="voteb">Vote</span>
                <span v-if="userVote && userVote == player.name" class="voted">Your Vote</span>
            </div>
            <div class="p-info">
                <p><span>Age</span> : <b> {{ player.age }} years old</b></p>
                <p><span>Nationality</span> : <b> {{ player.nationality }}</b>
                    <img class="nl" :src="player.nation_logo" alt="">
                </p>
                <p><span>Contract</span> : <b> {{ player.contract }}</b></p>
                <p><span>Position</span> : <b>{{ player.position }}</b></p>
                <p><span>Height</span> : <b>{{ player.height }} cm</b></p>
                <p><span>{{ ordinalMaker(player.seasons) }}</span><b> season at the club</b></p>
            </div>
            <img class="shirt" :src="shirt" alt="">
            <span class="number">{{ player.num }}</span>
        </div>
    </div>
</template>

<script>
import shirt from '@/assets/img/dfrg.png'
export default {
    inject: ['backendServer', 'currentHost', 'user_login_info', 'setFlashedMessage', 'loading'],
    props: ['players', 'motm', 'userVote'],
    data() {
        return {
            shirt: shirt,
            selectedIndex: null, // Track the selected player
        }
    },
    methods: {
        ordinalMaker(num) {
            if (num === 0) return (num + 1) + 'st';
            else if (num === 1) return num + 'st';
            else if (num === 2) return num + 'nd';
            else if (num === 3) return num + 'rd';
            else return num + 'th';
        },
        choosePlayer(index) {
            if (this.motm && !this.userVote && this.user_login_info) {
                this.selectedIndex = index;
            }
        },
        admitVote(event) {
            if (!this.user_login_info) {
                return;
            }

            this.loading();

            const requestData = {
                fixture_id: event.target.id,
                player: event.target.dataset.name
            };

            fetch(this.backendServer() + '/admit-vote', {
                method: "POST",
                credentials: "include",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestData)
            })
                .then((response) => response.json().then(data => ({ status: response.ok, data })))
                .then(({ status, data }) => {
                    this.loading(); // Stop loading indicator

                    if (!status) {
                        this.setFlashedMessage(data.error || "Failed to submit vote", "error");
                        return;
                    }
                    this.selectedIndex = null
                    // Show success message
                    this.setFlashedMessage(`Vote recorded for ${requestData.player}!`, "success");

                    // Emit success event to the parent (no message)
                    this.$emit('voteDone');

                })
                .catch((error) => {
                    this.loading(); // Stop loading indicator
                    console.error("Vote Error:", error);

                    // Show error message using setFlashedMessage
                    this.setFlashedMessage(error.message || "Something went wrong", "error");
                });
        }
        ,
        handleClickOutside(event) {
            if (this.motm && !this.userVote && this.user_login_info) {
                // Check if the click happened inside a ".squad-player" div
                if (!event.target.closest(".squad-player")) {
                    this.selectedIndex = null; // Reset selection if clicked outside a player
                }

            }
        }
    },
    computed: {
        playerss() {
            return this.players;
        }
    },
    mounted() {
        if (this.motm && !this.userVote && this.user_login_info) {
            window.addEventListener("click", this.handleClickOutside);

        }
    },
    beforeUnmount() {
        if (this.motm && !this.userVote) {
            window.removeEventListener("click", this.handleClickOutside);

        }
    }
}
</script>

<style>
:root {
    --max-font-width: 80px;
}

span.voteb:hover {
    background: rgb(103 103 103 / 80%) !important;
}

span.vc {
    font-size: 12px;
    left: 60px;
    color: darkgoldenrod;
    position: absolute;
    width: 60px;
    font-family: monospace;
    top: 190px;
}

span.voteb {
    position: absolute;
    top: 89px;
    padding: 10px;
    transform: translate(-50%, -50%);
    width: 75%;
    border-radius: 40px;
    background: rgb(47 41 51 / 80%) !important;
    left: 50%;
    cursor: pointer;
    color: white;
    transition: 0.3s opacity linear, 0.3s background-color linear, 0.3s color linear;
}

span.voted {
    position: absolute;
    top: 89px;
    padding: 10px;
    transform: translate(-50%, -50%);
    width: 75%;
    border-radius: 40px;
    background: rgb(47 41 51 / 80%) !important;
    left: 50%;
    color: white;
    transition: 0.3s opacity linear, 0.3s background-color linear, 0.3s color linear;
}

.selected-player {
    background: rgb(47 41 51 / 80%) !important;
    /* Add red border to the selected player */
}

.p-info {
    text-align: left;
    color: white;
    font-size: .72em;
    padding: 8px;
    margin-top: 98px;
}

.p-info p span {
    color: tomato
}

.p-info p {
    margin-bottom: 0;
}

.name {
    font-family: monospace;
    font-size: .85em
}

.squad-player img.nl {
    /* width: 18px; */
    width: 20px;
    border-radius: 4px;
    background: none;
}

span.number {
    position: absolute;
    right: 10.6px;
    text-align: center;
    bottom: 18px;
    color: black;
    font-family: monospace;
    min-width: 30px;
}

.motmsq {
    cursor: pointer;
}


.squad-player img.shirt {
    width: 43px;
    height: 43px;
    position: absolute;
    right: 4px;
    bottom: 6px;
}

.ianc {
    display: grid;
    justify-items: center;
    position: absolute;
    left: 50%;
    margin-bottom: 6px;
    transform: translate(-50%, -50%);
    color: #f5f5f5;
}

.squad-player img.playerpic {
    width: 175px;
    height: 175px;
    object-fit: cover;
    border: 3px solid rgb(26 20 20);
    border-radius: 50%;
    background: #f5f5f5;
}

.squad-players {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

.squad-player {
    background: rgb(27 14 35 / 80%);
    width: 175px;
    height: 225px;
    border-radius: 7px;
    margin: 52px 5px;
    position: relative;
}
</style>